module.exports = __webpack_public_path__ + "static/media/wowway.398214f6.jpg";